// Exports
export default {
	"touchNativeAppBanner": "touchNativeAppBanner_dB5OB",
	"fourButtonsLayout": "fourButtonsLayout_4aiVt",
	"left": "left_jUyZu",
	"title": "title_YSJwq",
	"description": "description_bvTcn",
	"right": "right_lIl5H",
	"spot": "spot_I5sNp",
	"phone": "phone_NRdeg"
};
